import {useIntl} from 'react-intl';
import React from 'react';
import {
  Checkbox,
  Button,
  Input
} from 'semantic-ui-react'

const FaceExam = (props: any) => {
    const intl = useIntl();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "5px" }}>
        <div
          style={{ padding: "5px",  backgroundColor: "#2D9CDB", color: "white", fontWeight: "bold", fontSize: "1.5em"}}>
          {intl.formatMessage({id: "cukey94"})}
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "25% 25% 50%", gridTemplateRows: "repeat(3, 1fr)" }}>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey77"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px", width:"45em" }}>
            <Checkbox
              checked={props.faceExamData?.facial1?.value}
              label="Symmetry"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "facial1", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Checkbox
              checked={props.faceExamData?.facial2?.value}
              label="Asymmetry"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "facial2", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "facial3", value: value, text: value, input: true } })}
              style={{width:"100%"}}
              value={props.faceExamData?.facial3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              {intl.formatMessage({id: "cukey194"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px", width:"45em" }}>
            
            <Checkbox
              checked={props.faceExamData?.skin1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "skin1", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Checkbox
              checked={props.faceExamData?.skin2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "skin2", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "skin3", value: value, text: value, input: true } })}
              style={{width:"100%"}}
              value={props.faceExamData?.skin3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              {intl.formatMessage({id: "cukey117"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px", width:"45em" }}>
            
            <Checkbox
              checked={props.faceExamData?.lymphNode1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "lymphNode1", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Checkbox
              checked={props.faceExamData?.lymphNode2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "lymphNode2", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedFaceExam", params: { name: "lymphNode3", value: value, text: value, input: true } })}
              style={{width:"100%"}}
              value={props.faceExamData?.lymphNode3?.value}>
            </Input>
          </div>
        </div>
        <div
          style={{display:"flex", justifyContent:"center"}}>
          
          <Button
            color="green"
            onClick={props.handleSaveFaceExam}
            style={{margin: "5px 0"}}>
            {intl.formatMessage({id: "cukey187"})}
          </Button>
        </div>
      </div>
    )
}

export default FaceExam

export const screenPropsDefault = {}

/* Date Time : Wed May 19 2021 03:14:29 GMT+0000 (Coordinated Universal Time)
/* Original screen Data **************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey94"})}
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",  backgroundColor: \"#2D9CDB\", color: \"white\", fontWeight: \"bold\", fontSize: \"1.5em\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"25% 25% 50%\", gridTemplateRows: \"repeat(3, 1fr)\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\", width:\"45em\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.facial1?.value"
        },
        "label": {
          "type": "value",
          "value": "Symmetry"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"facial1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey77"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent:\"center\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey187"})}
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSaveFaceExam"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 0\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.facial2?.value"
        },
        "label": {
          "type": "value",
          "value": "Asymmetry"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"facial2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "label",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey194"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\", width:\"45em\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Checkbox",
      "parent": 94,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.skin1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"skin1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Checkbox",
      "parent": 94,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.skin2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"skin2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Input",
      "parent": 94,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"skin3\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.faceExamData?.skin3?.value"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 8,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"facial3\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.faceExamData?.facial3?.value"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\", width:\"45em\" }"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey117"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "Checkbox",
      "parent": 106,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.lymphNode1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"lymphNode1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Checkbox",
      "parent": 106,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.faceExamData?.lymphNode2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"lymphNode2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 106,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedFaceExam\", params: { name: \"lymphNode3\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.faceExamData?.lymphNode3?.value"
        }
      },
      "seq": 110,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "FaceExam",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

************************************************************************************* */
